export function LoginIcon({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M63,80 L63,46 L143,46 L143,154 L63,154 L63,120"
        fill="none"
        stroke="var(--gold)"
        strokeWidth="8"
        strokeLinejoin="miter"
      />
      <path
        d="M37,100 L112,100 M93,83 L112,100 L93,117"
        fill="none"
        stroke="var(--gold)"
        strokeWidth="8"
        strokeLinecap="square"
        strokeLinejoin="miter"
      />
    </svg>
  );
}
